import React, { useEffect, useState, useRef } from "react";
import { connect } from "react-redux";
import * as actions from "../../../store/actions/index";
import { Map, Marker, Popup, TileLayer, GeoJSON } from "react-leaflet";
import L from "leaflet";
import MarkerClusterGroup from "react-leaflet-markercluster";
import axiosConfig from "../../../axiosConfig";
import { regionsCoordinates } from "./Bounds";
import StatusListInline from "../../Lists/StatusList/StatusList";
import { Link, useHistory } from "react-router-dom";
import Loading from "../../Loading/loading";
import 'react-leaflet-fullscreen/dist/styles.css';
import FullscreenControl from 'react-leaflet-fullscreen';
import endPoints from "../../../shared/endPoints.json";
import "./MainMap.css";

function MapContainer(props) {
  const [coordsArrayFromDb, setCoordsArrayFromDb] = useState(null);
  const zoom = 10.8;
  const [zoomRecorder, setZoomRecorder] = useState(zoom);
  const mapRef = useRef();
  const geoJsonRef = useRef();
  
  const {
    pointsStore,
    filteredPointsStore,
    isFiltered,
    editMapState
  } = props;

  const [styleGeoJson, setStyleGeoJson] = useState({
    color: "#7652f7",
    weight: 4,
    opacity: 1,
    fillColor: "purple",
    fillOpacity: 0.3,
  });

  const handleZoom = (e) => {
    let layer = e.target;

    layer.setStyle({
      weight: 2.8,

      opacity: 1,

      fillColor: "transparent",

      fillOpacity: 1,
    });

    mapRef.current.leafletElement.fitBounds(e.target.getBounds());
  };

  function changeBounds(boundsArray) {
    let newBoundsArray = boundsArray.map((element) => {
      return [element[1], element[0]];
    });
    return newBoundsArray;
  }

  const getLatLngBounds = () => {
    if (coordsArrayFromDb) {
      let polygon = new L.polygon(
        changeBounds(
          regionsCoordinates(coordsArrayFromDb).features[0].geometry
            .coordinates[0]
        )
      );
      let polycenter = polygon.getBounds().getCenter();
      return polycenter;
    }
  };


  let idForAtagsMap = "linkForOpenAlertTable";

  const filterMap = (id, alertScore, statusId) => {
    window.scrollTo(0, document.body.scrollHeight);
    editMapState({
      objectForTableFiltering: {
        beneficiaryId: id,
        alertScore: alertScore,
        statusId: statusId
      },
    });
  };

  const onEachFeature = (feature, layer) => {
    layer.on({
      click: handleZoom,
    });
  };

  const openPopup = (e) => {
    e.target.openPopup();
  };

  useEffect(() => {
    let geoJsonStyleTemporary =
      zoomRecorder <= 11.1
        ? {
          color: "#7652f7",

          weight: 4,

          opacity: 1,

          fillColor: "purple",

          fillOpacity: 0.3,
        }
        : {
          color: "#7652f7",

          weight: 1,

          opacity: 1,

          fillColor: "transparent",

          fillOpacity: 1,
        };

    setStyleGeoJson(geoJsonStyleTemporary);
  }, [zoomRecorder]);

  useEffect(() => {
    editMapState({
      filteredPointsStore: pointsStore,
    });
    //zoomToAlert();
  }, [pointsStore]);

  useEffect(() => {
    axiosConfig
      .get(`/Municipality`)
      .then((municipalityObj) => {
        let municipalityObjInArray = [municipalityObj.data];
        setCoordsArrayFromDb(municipalityObjInArray);
      });
  }, []);

  let pointsPerCase;
  !isFiltered
    ? (pointsPerCase = pointsStore)
    : (pointsPerCase = filteredPointsStore);

  if (pointsStore && filteredPointsStore) {
    return (
      <div style={{ height: "100%" }}>
        <Map
          center={getLatLngBounds()}
          maxZoom={15}
          zoom={zoom}
          ref={mapRef}
          onzoomend={() => {
            setZoomRecorder(mapRef.current.leafletElement.getZoom());
          }}
        >
          <TileLayer
            url={endPoints.OSMMAPTILEURL}
            attribution={`&copy; <a href="${endPoints.OSMCOPYRIGHTLINK}">OpenStreetMap</a> contributors`}
          />
          <MarkerClusterGroup>
            {pointsPerCase.map((place, index) => {

              if (place && place.latitude && place.longitude) {
                let
                  redOpenCount = 0,
                  orangeOpenCount = 0,
                  yellowOpenCount = 0,
                  redAssignedCount = 0,
                  orangeAssignedCount = 0,
                  yellowAssignedCount = 0;
                place.alarms.forEach((alarm) => {
                  if (alarm.alarmSeverity === "Low" && alarm.statusId === 1) {
                    yellowOpenCount++;
                  }
                  else if (alarm.alarmSeverity === "Low" && alarm.statusId === 2) {
                    yellowAssignedCount++;
                  }
                  else if (alarm.alarmSeverity === "Middle" && alarm.statusId === 1) {
                    orangeOpenCount++;
                  } else if (alarm.alarmSeverity === "Middle" && alarm.statusId === 2) {
                    orangeAssignedCount++;
                  }
                  else if (alarm.alarmSeverity === "High" && alarm.statusId === 1) {
                    redOpenCount++;
                  }
                  else if (alarm.alarmSeverity === "High" && alarm.statusId === 2) {
                    redAssignedCount++;
                  }
                });
                return (
                  <Marker
                    onclick={openPopup}
                    icon={place.iconUrl}
                    key={index}
                    position={[place.latitude, place.longitude]}
                  >
                    <Popup>
                      {place.highestAlarmDescription ? (
                        <div>
                          <div className="iconContainer">
                            <img
                              src={place.iconUrl.options.iconUrl}
                              alt={place.highestAlarmSeverity}
                            />
                            <div className="iconContainer_titles">
                              Κωδ.Ωφελούμενου : {place.beneficiaryId}
                            </div>
                            <div className="iconContainer_titles">
                              Φύλο : {(place.genderId === 1) ? 'Άντρας' : 'Γυναίκα'}
                            </div>
                            <div className="iconContainer_titles">
                              Ηλικία : {place.age}
                            </div>
                            <div className="iconContainer_titles">
                              Δείκτης Κινδύνου :  {(place.highestAlarmSeverity === "High") ? 'Υψηλή' : place.highestAlarmSeverity === "Middle" ? "Μέτρια" : "Χαμηλή"}
                            </div>
                            <div className="iconContainer_titles">
                              Τύπος Ειδοποίησης : {place.highestAlarmDescription}
                            </div>
                          </div>
                          <div className="iconContainerAlarms">
                            <div className="Specific_AlertTypes">
                              <Link
                                to="#"
                                className={idForAtagsMap}
                                onClick={() => {
                                  filterMap(place.beneficiaryId, null, 1);
                                  props.handleChange("", 0);
                                }}
                              >
                                <div className="iconContainer_titles">
                                  {" "}
                                  <b>Ανοιχτές:{" "}</b>
                                  <span
                                    style={{
                                      fontWeight: "bold",
                                      color: "black",
                                      fontSize: 12
                                    }}
                                  >
                                    {redOpenCount + orangeOpenCount + yellowOpenCount}
                                  </span>
                                </div>
                              </Link>
                              <div
                                className="iconContainer_titles"
                                style={{ fontSize: 12 }}
                              >
                                <Link
                                  to="#"
                                  className={idForAtagsMap}
                                  onClick={() => {
                                    filterMap(place.beneficiaryId, "High", 1);
                                    props.handleChange("", 0);
                                  }
                                  }
                                >
                                  {" "}
                                  Υψηλού:{" "}
                                  <span
                                    style={{
                                      fontWeight: "bold",
                                      color: "red",
                                    }}
                                  >
                                    {redOpenCount}
                                  </span>
                                </Link>
                              </div>
                              <div
                                className="iconContainer_titles"
                                style={{ fontSize: 12 }}
                              >
                                <Link
                                  to="#"
                                  className={idForAtagsMap}
                                  onClick={() => {
                                    filterMap(place.beneficiaryId, "Middle", 1);
                                    props.handleChange("", 0);
                                  }
                                  }
                                >
                                  {" "}
                                  Μετρίου:{" "}
                                  <span
                                    style={{
                                      fontWeight: "bold",
                                      color: "#ff8c00",
                                    }}
                                  >
                                    {orangeOpenCount}
                                  </span>
                                </Link>
                              </div>
                              <div
                                className="iconContainer_titles"
                                style={{ fontSize: 12 }}
                              >
                                <Link
                                  to="#"
                                  className={idForAtagsMap}
                                  onClick={() => {
                                    filterMap(place.beneficiaryId, "Low", 1);
                                    props.handleChange("", 0);
                                  }
                                  }
                                >
                                  {" "}
                                  Χαμηλού:{" "}
                                  <span
                                    style={{
                                      fontWeight: "bold",
                                      color: "#fcba03",
                                    }}
                                  >
                                    {yellowOpenCount}
                                  </span>
                                </Link>
                              </div>
                            </div>
                            <div className="Specific_AlertTypes">
                              <Link
                                to="#"
                                className={idForAtagsMap}
                                onClick={() => {
                                  filterMap(place.beneficiaryId, null, 2);
                                  props.handleChange("", 1);
                                }}
                              >
                                <div className="iconContainer_titles">
                                  {" "}
                                  <b>Σε εξέλιξη:{" "}</b>
                                  <span
                                    style={{
                                      fontWeight: "bold",
                                      color: "black",
                                      fontSize: 12
                                    }}
                                  >
                                    {redAssignedCount + orangeAssignedCount + yellowAssignedCount}
                                  </span>
                                </div>
                              </Link>
                              <div
                                className="iconContainer_titles"
                                style={{ fontSize: 12 }}
                              >
                                <Link
                                  to="#"
                                  className={idForAtagsMap}
                                  onClick={() => {
                                    filterMap(place.beneficiaryId, "High", 2);
                                    props.handleChange("", 1);
                                  }}
                                >
                                  {" "}
                                  Υψηλού:{" "}
                                  <span
                                    style={{
                                      fontWeight: "bold",
                                      color: "red",
                                    }}
                                  >
                                    {redAssignedCount}
                                  </span>
                                </Link>
                              </div>
                              <div
                                className="iconContainer_titles"
                                style={{ fontSize: 12 }}
                              >
                                <Link
                                  to="#"
                                  className={idForAtagsMap}
                                  onClick={() => {
                                    filterMap(place.beneficiaryId, "Middle", 2);
                                    props.handleChange("", 1);
                                  }}
                                >
                                  {" "}
                                  Μετρίου:{" "}
                                  <span
                                    style={{
                                      fontWeight: "bold",
                                      color: "#ff8c00",
                                    }}
                                  >
                                    {orangeAssignedCount}
                                  </span>
                                </Link>
                              </div>
                              <div
                                className="iconContainer_titles"
                                style={{ fontSize: 12 }}
                              >
                                <Link
                                  to="#"
                                  className={idForAtagsMap}
                                  onClick={() => {
                                    filterMap(place.beneficiaryId, "Low", 2);
                                    props.handleChange("", 1);
                                  }}
                                >
                                  {" "}
                                  Χαμηλού:{" "}
                                  <span
                                    style={{
                                      fontWeight: "bold",
                                      color: "#fcba03",
                                    }}
                                  >
                                    {yellowAssignedCount}
                                  </span>
                                </Link>
                              </div>
                            </div>
                          </div>
                        </div>
                      ) : (
                        <div className="iconContainer">
                          <img
                            src={place.iconUrl.options.iconUrl}
                            alt={"Χωρίς Κίνδυνο"}
                          />
                          <div>{"Χωρίς Κίνδυνο"}</div>
                          <div className="sections">
                            <div className={"section" + " " + "Normal"}>
                              <div>Κωδ.Ωφελούμενου:</div>
                              <div>{place.beneficiaryId}</div>
                            </div>
                            <div className={"section" + " " + "Normal"}>
                              <div>Φύλο:</div>
                              <div>{(place.genderId === 1) ? 'Άντρας' : 'Γυναίκα'}</div>
                            </div>

                            <div className={"section" + " " + "Normal"}>
                              <div>Ηλικία:</div>
                              <div>{place.age}</div>
                            </div>

                          </div>
                        </div>
                      )}
                    </Popup>
                  </Marker>
                );
              }
            })}
          </MarkerClusterGroup>
          <FullscreenControl position="topleft" />
        </Map>
        <StatusListInline />
      </div>
    );
  } else {
    return <Loading></Loading>;
  }
}

const mapStateToProps = (state) => {
  return {
    ...state.map,
    ...state.auth,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    editMapState: (mapPayload) => {
      dispatch(actions.editMapState(mapPayload));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MapContainer);
